export default "__VITE_ASSET__B3Wxwa7l__"